import { render } from "./Reports.vue?vue&type=template&id=984b6fbe&scoped=true&ts=true"
import script from "./Reports.vue?vue&type=script&lang=ts"
export * from "./Reports.vue?vue&type=script&lang=ts"

import "./Reports.vue?vue&type=style&index=0&id=984b6fbe&lang=css"
import "./Reports.vue?vue&type=style&index=1&id=984b6fbe&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khale\\Cookies BIS\\Core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-984b6fbe"]])

export default __exports__